import { render, staticRenderFns } from "./CustomerDebts.vue?vue&type=template&id=0a0ba7de&"
import script from "./CustomerDebts.vue?vue&type=script&lang=js&"
export * from "./CustomerDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports